<app-user-email-contacts [cmsModel]="cmsModel" [title]="title" [contacts]="contacts"
    (sendEmailEmitter)="sendEmail($event)" [isEmailSuccess]="isEmailSuccess"
    [showEmailPopUpModal]="showEmailPopUpModal"></app-user-email-contacts>